import { render, staticRenderFns } from "./PermissionDenied.vue?vue&type=template&id=44f6e684&scoped=true"
import script from "./PermissionDenied.vue?vue&type=script&lang=js"
export * from "./PermissionDenied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f6e684",
  null
  
)

export default component.exports